// matches #111, #123456, rgb(1, 2, 3), rgba(1%, 2, 3%, 0.5), hsl(5, 6, 7), hsla(8, 8, 8, 0.6)
// eslint-disable-next-line max-len
const colorRegex =
    /(#([\da-f]{3}){1,2}|(rgb|hsl)a\((\d{1,3}%?,\s?){3}(1|0?\.\d+)\)|(rgb|hsl)\(\d{1,3}%?(,\s?\d{1,3}%?){2}\))/i
const isColor = color => colorRegex.test(color)

export default isColor
